import * as ko from 'knockout';
import { BaseProperty, IPropertyDescription } from 'Core/GeneralProperties/Managers/BaseProperty';

import Template from 'Core/GeneralProperties/Managers/GridLayoutProperty/Templates/GridLayoutProperty.html';
import { VueApp } from 'VueApp';
import GridLayoutPropertyComponent from './GridLayoutProperty.vue';
import { IControl } from 'Core/Controls/IControl';

ko.templates['Core/GeneralProperties/Managers/GridLayoutProperty/Templates/GridLayoutProperty'] =
    Template;

export interface LayoutOptions {
    name?: 'MidCards' | 'SmallCards' | 'FilesView' | null | string;
    pictureField?: string | null;
    documentField?: string | null;
    labelField?: string | null;
    priceField?: string | null;
    subtitleField1?: string | null;
    subtitleField2?: string | null;
    subtitleField3?: string | null;
    subtitleText1?: Record<string, string>;
    subtitleText2?: Record<string, string>;
    subtitleText3?: Record<string, string>;
}

export class GridLayoutProperty extends BaseProperty {
    private _valueSubscription?: KnockoutSubscription;
    private _enabledSubscription?: KnockoutSubscription;
    private _control: IControl;

    constructor(
        property: IPropertyDescription,
        propertyValue: LayoutOptions,
        control: IControl
    ) {
        super(property);
        this._control = control;
        this.Value = ko.observable(propertyValue);
    }

    GetTemplateName(): string {
        return 'Core/GeneralProperties/Managers/GridLayoutProperty/Templates/GridLayoutProperty';
    }

    GetDefaultValue(): LayoutOptions {
        return {
            name: '',
            pictureField: '',
            documentField: '',
            labelField: '',
            priceField: '',
            subtitleField1: '',
            subtitleField2: '',
            subtitleField3: '',
            subtitleText1: {},
            subtitleText2: {},
            subtitleText3: {},
        };
    }

    SetValue(propertyValue: LayoutOptions): void {
        this.Value(propertyValue);
    }

    IsValid(): boolean {
        const layoutOptions = this.Value() as LayoutOptions;

        if (!layoutOptions?.name) {
            return true;
        }

        if (!layoutOptions?.name) {
            return;
        }

        if(layoutOptions?.name == 'FilesView'){
            if (!layoutOptions.documentField) {
                this._errorMessage = 'Document is required.';
                return false;
            }
        } else {
            if (!layoutOptions.pictureField) {
                this._errorMessage = 'Picture is required.';
                    return false;
            }

            if (!layoutOptions.labelField) {
                this._errorMessage = 'Label is required.';
                return false;
            }
        }

        return true;
    }

    ErrorMessage(): string {
        return this._errorMessage;
    }

    AfterRender(elements: Array<HTMLElement>) {
        if (!elements || !elements.length) {
            return;
        }

        const mountPoint = elements[0] as HTMLElement;

        VueApp.Mount(GridLayoutPropertyComponent, mountPoint, {
            control: this._control,
            modelValue: this.Value(),
            'onUpdate:modelValue': (value) => {
                this.Value(value);
            },
        });

        this._valueSubscription?.dispose();
        this._enabledSubscription?.dispose();

        ko.utils.domNodeDisposal.addDisposeCallback(mountPoint, () => {
            this._valueSubscription?.dispose();
            this._enabledSubscription?.dispose();
        });
    }
}
